import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Credential Vault API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const credentialVaultService = {
  getAll: (params = {}) => {
    return api.get('/credential-vault', { params });
  },

  getStats: () => {
    return api.get('/credential-vault/stats');
  },

  create: (data) => {
    return api.post('/credential-vault', data);
  },

  update: (id, data) => {
    return api.put(`/credential-vault/${id}`, data);
  },

  delete: (id) => {
    return api.delete(`/credential-vault/${id}`);
  },

  decrypt: (id) => {
    return api.post(`/credential-vault/${id}/decrypt`);
  },

  getAccessGrants: (id) => {
    return api.get(`/credential-vault/${id}/access`);
  },

  grantAccess: (id, data) => {
    return api.post(`/credential-vault/${id}/access`, data);
  },

  getAuditLog: (id) => {
    return api.get(`/credential-vault/${id}/audit`);
  },

  bulkImport: (payload) => {
    return api.post('/credential-vault/import', payload);
  },
};

export default credentialVaultService;
